import { notificationConstants } from "../_constants";

export const addNotification = (message) => {
  return {
    type: notificationConstants.NOTIFICATION_RECEIVED,
    message
  }
}
